import React, { useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@gje/icons';
import { getText } from '../../../../../services/text/text-service';
import { Row } from './CoverageDetailsMobile/Row';
import { ExpandableBulletText } from '../../../../components/ExpandableBulletText/ExpandableBulletText';
import uuid from 'uuid';
import { resolvePaymentTerm } from '../../../../../services/calculation-data/calculation-data-service';
import { numberWithSpaces } from '../../../../../utils/stringUtils';
import useWidth from '../../../../../hooks/useWidth';
import { getPrice, resolveQuestion } from './CoverageDetails';
import { isAndroid } from 'react-device-detect';

export const CoverageDetailsMobile = props => {
    const width = useWidth();
    let slider = null;
    const [actualIndex, setActualIndex] = useState(props.selectedIndex);

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: props.selectedIndex,
        beforeChange(oldIndex: number, newIndex: number): void {
            setActualIndex(newIndex);
            props.setSelectedCoverage(
                props.coverages[newIndex].coverageProduct
            );
        },
        centerMode: true,
        centerPadding: '30px',
        nextArrow: (
            <KeyboardArrowRight
                onClick={() => slider.slickNext()}
                className={'mobile-arrow-right'}
            />
        ),
        prevArrow: (
            <KeyboardArrowLeft
                onClick={() => slider.slickPrev()}
                className={'mobile-arrow-left'}
            />
        )
    };

    const renderDetailsRows = (details, id, color) => {
        return details.map((value, index) => {
            if (resolveQuestion(value[id])) {
                return (
                    <Row
                        className={
                            'no-padding-left-right border-bottom-2-white'
                        }
                        color={color}>
                        <div className={'row display-flex align-items'}>
                            <div
                                className={`col-xs-16 
                                    ${
                                        width <= 370
                                            ? 'no-padding-left-right'
                                            : ''
                                    } 
                                    min-height-100 border-right-2-white
                                    ${
                                        index === 0
                                            ? 'padding-bottom-25'
                                            : 'padding-top-bottom-25'
                                    }`}>
                                <ExpandableBulletText
                                    className={'label-font-weight'}
                                    text={value.coverageDesc}
                                    helpText={value.coverageSubDesc}
                                    arrowSize={12}
                                />
                            </div>
                            <div
                                className={`
                                col-xs-7 min-height-100
                                padding-top-bottom-25`}>
                                {resolveQuestion(value[id])}
                            </div>
                        </div>
                    </Row>
                );
            } else {
                return '';
            }
        });
    };

    if (
        isAndroid &&
        document.getElementsByClassName('slick-arrow').length != 0
    ) {
        Array.from(document.getElementsByClassName('slick-arrow')).forEach(
            value => {
                value.classList.add('slick-prev-android', 'slick-next-android');
            }
        );
    }

    const renderDots = length => {
        const array = [];
        for (let i = 0; i < length; i++) {
            if (i === actualIndex) {
                array.push(
                    <span
                        className={`
                        ${isAndroid ? 'font-size-20' : 'font-size-30'}
                         margin-5`}
                        style={{ color: 'grey' }}>
                        &#9632;
                    </span>
                );
            } else {
                array.push(
                    <span
                        className={`
                        ${isAndroid ? 'font-size-20' : 'font-size-30'}
                         margin-5`}
                        style={{ color: 'white' }}>
                        &#9632;
                    </span>
                );
            }
        }
        return array;
    };

    const renderRows = () => {
        return props.coverages.map((coverage, index) => {
            let cover =
                props.coveragesConfig.coverages[coverage.coverageProduct];
            return (
                <div className={'padding-left-right-5'} key={uuid.v4()}>
                    <Row
                        id={'ios-overflow'}
                        className={'padding-25 z-index-above no-padding-bottom'}
                        color={cover.color}>
                        <h1
                            className={
                                'margin-top-25 font-size-35 title-without-bold'
                            }>
                            {cover.name}
                        </h1>
                    </Row>
                    <Row className={'padding-25'} color={cover.color}>
                        <h1
                            className={
                                'font-size-40 margin-right-10 display-inline-flex'
                            }>
                            {numberWithSpaces(
                                getPrice(
                                    coverage.coverageProduct,
                                    props.coverages
                                )
                            )}
                        </h1>
                        <h1
                            className={
                                'display-inline-flex title-without-bold'
                            }>
                            {resolvePaymentTerm(
                                props.paymentTerm,
                                coverage.price
                            )}
                        </h1>
                    </Row>
                    <Row
                        color={cover.color}
                        className={
                            'no-padding-top no-padding-bottom padding-25'
                        }>
                        <div>{renderDots(props.coverages.length)}</div>
                    </Row>
                    <Row className={'padding-25'} color={cover.color}>
                        <h1>
                            {getText(
                                'webshopsweden.products.employeeHealthcare.notIncluded'
                            )}
                        </h1>
                    </Row>
                    {renderDetailsRows(
                        props.coveragesConfig.coveragesDetails,
                        coverage.coverageProduct,
                        cover.color
                    )}
                </div>
            );
        });
    };

    return (
        <div className={'margin-top-39 margin-bottom-39'}>
            <Slider
                {...settings}
                ref={s => {
                    slider = s;
                }}
                className={'text-center'}>
                {renderRows()}
            </Slider>
        </div>
    );
};
